(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/quick-search-pills/assets/javascripts/quick-search-pills.js') >= 0) return;  svs.modules.push('/components/casino-react/quick-search-pills/assets/javascripts/quick-search-pills.js');

'use strict';

const searchTerms = svs.casino_react.shared.data.cmsPopularSearchTerms;
const {
  ReactButton: Button,
  ReactIcon: Icon
} = svs.ui;
const {
  useSetSearchParams
} = svs.components.casino_react.hooks;
const QuickSearchPills = () => {
  const {
    setQuery
  } = useSetSearchParams();
  if (!searchTerms.length) {
    return null;
  }
  return React.createElement("div", {
    className: "quick-search-pills"
  }, searchTerms.map(term => React.createElement(Button, {
    className: "quick-search-pills__pill",
    iconPosition: "left",
    key: term,
    onClick: () => setQuery(term),
    rounded: true
  }, React.createElement(Icon, {
    icon: "search"
  }), term)));
};
setGlobal('svs.components.casino_react.quickSearchPills.QuickSearchPills', QuickSearchPills);

 })(window);